import StorePage from './StorePage';
export default StorePage;
